



























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ActivityInterface from '@/interfaces/ActivityInterface';

@Component
export default class Activities extends Vue {
    @Prop({ required: true, type: Array })
    public activities!: ActivityInterface[];
}
